import React, { useEffect, useState } from "react";
import { Controller } from "react-hook-form";

const CheckboxGroup = ({
  control,
  errors,
  label,
  name,
  rules,
  options,
  disabled,
  className,
  styles,
  labelClassName,
  labelStyles,
  watch,
}) => {
  const watchValue = watch(name);

  return (
    <div className={`flex flex-col items-start ${className}`}>
      <label
        htmlFor={name}
        className={`form-label font-bold float-start mb-1 ${labelClassName}`}
        style={labelStyles}
      >
        {rules?.required && <span className="text-red-500">*</span>} {label}
      </label>
      <div className="flex flex-col items-start">
        <Controller
          name={name}
          control={control}
          rules={rules}
          defaultValue={[]}
          render={({ field }) => (
            <>
              {options?.map((option, index) => (
                <div key={index} className="flex items-center mb-1">
                  <input
                    type="checkbox"
                    id={`${name}-${option.value}`}
                    value={option.value}
                    disabled={disabled}
                    checked={Array.isArray(field.value) && field.value.includes(option.value)}
                    onChange={(e) => {
                      const newValue = Array.isArray(field.value) ? [...field.value] : [];
                      if (e.target.checked) {
                        newValue.push(option.value);
                      } else {
                        const index = newValue.indexOf(option.value);
                        if (index > -1) {
                          newValue.splice(index, 1);
                        }
                      }
                      field.onChange(newValue);
                    }}
                    className={`h-3 w-3 text-blue-600 rounded focus:ring-blue-500 ${disabled ? 'cursor-not-allowed opacity-50' : ''}`}
                    style={styles}
                    aria-invalid={!!errors[name]}
                    aria-describedby={errors[name] ? `${name}-error` : undefined}
                  />
                  <label
                    htmlFor={`${name}-${option.value}`}
                    className="ml-2 "
                  >
                    {option.label}
                  </label>
                </div>
              ))}
            </>
          )}
        />
      </div>
      {errors[name] && (
        <span id={`${name}-error`} className="text-red-500 text-sm mt-1">
          {errors[name].message}
        </span>
      )}
    </div>
  );
};

export default CheckboxGroup;
